import AccountSettingActivity from '@activities/account/AccountSettingActivity';
import AccountTerminationActivity from '@activities/account/AccountTerminationActivity';
import LogoutModal from '@activities/account/LogoutModal';
import NickNameChangeModal from '@activities/account/NickNameChangeModal';
import AlertActivity from '@activities/AlertActivity';
import AppTerminationModal from '@activities/AppTerminationModal';
import IdentifyFailActivity from '@activities/auth/IdentifyFailActivity';
import IdentifySuccessActivity from '@activities/auth/IdentifySuccessActivity';
import SignInActivity from '@activities/auth/SignInActivity';
import SignInWithAppleActivity from '@activities/auth/SignInWithAppleActivity';
import SignInWithGoogleActivity from '@activities/auth/SignInWithGoogleActivity';
import SignInWithKakaoActivity from '@activities/auth/SignInWithKakaoActivity';
import SignInWithPhoneActivity from '@activities/auth/SignInWithPhoneActivity';
import SignUpActivity from '@activities/auth/SignUpActivity';
import CartActivity from '@activities/cart/CartActivity';
import CloseInquiryModal from '@activities/customerService/CloseInquiryModal';
import CustomerServiceActivity from '@activities/customerService/CustomerServiceActivity';
import InquiryActivity from '@activities/customerService/InquiryActivity';
import InquiryCommentBottomSheet from '@activities/customerService/InquiryCommentBottomSheet';
import InquiryCommentModal from '@activities/customerService/InquiryCommentModal';
import InquiryLogActivity from '@activities/customerService/InquiryLogActivity';
import EasyCardActivity from '@activities/easyCard/EasyCardActivity';
import PaymentFailedActivity from '@activities/errors/PaymentFailedActivity';
import UserPaymentCancelActivity from '@activities/errors/UserPaymentCancelActivity';
import ForceUpdateModal from '@activities/ForceUpdateModal';
import GiftCanceledModal from '@activities/gift/GiftCanceledModal';
import GiftCancelModal from '@activities/gift/GiftCancelModal';
import GiftItemActivity from '@activities/gift/GiftItemActivity';
import GiftOrderActivity from '@activities/gift/GiftOrderActivity';
import GiftOrderCompleteActivity from '@activities/gift/GiftOrderCompleteActivity';
import GiftReceivedActivity from '@activities/gift/GiftReceivedActivity';
import GiftsActivity from '@activities/gift/GiftsActivity';
import GiftSentActivity from '@activities/gift/GiftSentActivity';
import NewGiftBottomSheet from '@activities/gift/NewGiftBottomSheet';
import ItemActivity from '@activities/items/ItemActivity';
import ItemNutritionModal from '@activities/items/ItemNutritionModal';
import ItemsActivity from '@activities/items/ItemsActivity';
import PersonalOptionActivity from '@activities/items/PersonalOptionActivity';
import LinkActivity from '@activities/LinkActivity';
import MainActivity from '@activities/MainActivity';
import ExternalShopModal from '@activities/MainActivity/components/QuickOrder/ExternalShopModal';
import ItemSoldOutModal from '@activities/MainActivity/ItemSoldOutModal';
import NotOperationModal from '@activities/MainActivity/NotOperationModal';
import CouponActivity from '@activities/membership/coupon/CouponActivity';
import CouponDetailActivity from '@activities/membership/coupon/CouponDetailActivity';
import CouponDownloadModal from '@activities/membership/coupon/CouponDownloadModal';
import PointActivity from '@activities/membership/point/PointActivity';
import AttendanceCheckActivity from '@activities/membership/stamp/AttendanceCheckActivity';
import StampsActivity from '@activities/membership/stamp/StampsActivity';
import StampScopeBottomSheet from '@activities/membership/stamp/StampScopeBottomSheet';
import StampSortBottomSheet from '@activities/membership/stamp/StampSortBottomSheet';
import MyMenuActivity from '@activities/myMenu/MyMenuActivity';
import BoardActivity from '@activities/news/BoardActivity';
import EventActivity from '@activities/news/EventActivity';
import NoticeActivity from '@activities/news/NoticeActivity';
import NotificationActivity from '@activities/NotificationActivity';
import CancelOrderModal from '@activities/order/CancelOrderModal';
import DiscountCouponBottomSheet from '@activities/order/DiscountCouponBottomSheet';
import FingerPayActivity from '@activities/order/FingerPayActivity';
import OrderActivity from '@activities/order/OrderActivity';
import OrderCompleteActivity from '@activities/order/OrderCompleteActivity';
import OrderLogActivity from '@activities/order/OrderLogActivity';
import OrderLogsActivity from '@activities/order/OrderLogsActivity';
import OrderReceiptActivity from '@activities/order/OrderReceiptActivity';
import TossOrderFailActivity from '@activities/order/toss/TossOrderFailActivity';
import TossOrderSuccessActivity from '@activities/order/toss/TossOrderSuccessActivity';
import PermissionBottomSheet from '@activities/PermissionBottomSheet';
import MyPrepaidCardActivity from '@activities/prepaidCard/MyPrepaidCardActivity';
import PrepaidCardChargeActivity from '@activities/prepaidCard/PrepaidCardChargeActivity';
import PrepaidCardChargeCompleteActivity from '@activities/prepaidCard/PrepaidCardChargeCompleteActivity';
import PrepaidCardImageActivity from '@activities/prepaidCard/PrepaidCardImageActivity';
import PrepaidCardImagesActivity from '@activities/prepaidCard/PrepaidCardImagesActivity';
import PrepaidCardLogActivity from '@activities/prepaidCard/PrepaidCardLogActivity';
import PrepaidCardManageActivity from '@activities/prepaidCard/PrepaidCardManageActivity';
import DeleteAllPrepaidCardsModal
    from '@activities/prepaidCard/PrepaidCardManageActivity/modal/DeleteAllPrepaidCardsModal';
import PrepaidCardOrderCompleteActivity from '@activities/prepaidCard/PrepaidCardOrderCompleteActivity';
import ProjectActivity from '@activities/ProjectActivity';
import ShopDetailBottomSheet from '@activities/shops/ShopDetailBottomSheet';
import ShopListActivity from '@activities/shops/ShopListActivity';
import ShopLocationBottomSheet from '@activities/shops/ShopLocationBottomSheet';
import ShopPrepareModal from '@activities/shops/ShopPrepareModal';
import TermDetailActivity from '@activities/terms/TermDetailActivity';
import TestActivity from '@activities/test/TestActivity';
import TierBenefitsBottomSheet from '@activities/tier/TierBenefitsBottomSheet';
import TierCalculatedDateBottomSheet from '@activities/tier/TierCalculatedDateBottomSheet';
import TierHistoryActivity from '@activities/tier/TierHistoryActivity';
import WithdrawManualActivity from '@activities/WithdrawManualActivity';
import BarcodeModal from '@modals/BarcodeModal';
import { basicUIPlugin } from '@stackflow/plugin-basic-ui';
import { historySyncPlugin } from '@stackflow/plugin-history-sync';
import { basicRendererPlugin } from '@stackflow/plugin-renderer-basic';
import { stackflow } from '@stackflow/react';

export const {
    Stack, useFlow, activities, useStepFlow,
} = stackflow({
    transitionDuration: 350,
    activities: {
        MainActivity,
        NotOperationModal,
        ItemSoldOutModal,
        NotificationActivity,
        SignInActivity,
        SignInWithPhoneActivity,
        SignInWithKakaoActivity,
        SignInWithAppleActivity,
        SignInWithGoogleActivity,
        SignUpActivity,
        IdentifySuccessActivity,
        IdentifyFailActivity,
        TermDetailActivity,
        BoardActivity,
        EventActivity,
        NoticeActivity,
        ShopListActivity,
        ShopLocationBottomSheet,
        ShopDetailBottomSheet,
        ShopPrepareModal,
        ItemsActivity,
        ItemActivity,
        ItemNutritionModal,
        PersonalOptionActivity,
        OrderActivity,
        DiscountCouponBottomSheet,
        FingerPayActivity,
        CustomerServiceActivity,
        InquiryActivity,
        InquiryLogActivity,
        CloseInquiryModal,
        InquiryCommentModal,
        InquiryCommentBottomSheet,
        ProjectActivity,
        OrderLogsActivity,
        OrderLogActivity,
        OrderReceiptActivity,
        OrderCompleteActivity,
        CancelOrderModal,
        AccountSettingActivity,
        AccountTerminationActivity,
        NickNameChangeModal,
        LogoutModal,
        GiftsActivity,
        GiftItemActivity,
        GiftSentActivity,
        GiftReceivedActivity,
        GiftOrderActivity,
        GiftOrderCompleteActivity,
        GiftCancelModal,
        GiftCanceledModal,
        NewGiftBottomSheet,
        MyPrepaidCardActivity,
        PrepaidCardImagesActivity,
        PrepaidCardImageActivity,
        PrepaidCardManageActivity,
        PrepaidCardChargeActivity,
        PrepaidCardOrderCompleteActivity,
        PrepaidCardLogActivity,
        DeleteAllPrepaidCardsModal,
        PrepaidCardChargeCompleteActivity,
        MyMenuActivity,
        PointActivity,
        StampsActivity,
        StampScopeBottomSheet,
        StampSortBottomSheet,
        CartActivity,
        BarcodeModal,
        CouponActivity,
        CouponDetailActivity,
        CouponDownloadModal,
        ExternalShopModal,
        UserPaymentCancelActivity,
        PaymentFailedActivity,
        AlertActivity,
        PermissionBottomSheet,
        LinkActivity,
        TestActivity,
        AppTerminationModal,
        ForceUpdateModal,
        AttendanceCheckActivity,
        EasyCardActivity,
        WithdrawManualActivity,
        TossOrderSuccessActivity,
        TossOrderFailActivity,
        TierBenefitsBottomSheet,
        TierHistoryActivity,
        TierCalculatedDateBottomSheet,
    },
    plugins: [
        basicRendererPlugin(),
        basicUIPlugin({
            theme: 'cupertino',
        }),
        historySyncPlugin({
            routes: {
                MainActivity: '/',
                NotOperationModal: '/not-operation',
                ItemSoldOutModal: 'item-sold-out',
                NotificationActivity: '/notifications',
                SignInActivity: '/auth/sign-in',
                SignInWithPhoneActivity: '/auth/sign-in/phone',
                SignInWithKakaoActivity: '/auth/sign-in/kakao',
                SignInWithAppleActivity: '/auth/sign-in/apple',
                SignInWithGoogleActivity: '/auth/sign-in/google',
                SignUpActivity: '/auth/sign-up',
                IdentifySuccessActivity: '/identity/done',
                IdentifyFailActivity: '/errors/identity-failed',
                TermDetailActivity: '/terms',
                BoardActivity: '/boards',
                EventActivity: '/events/:eventId',
                NoticeActivity: '/notices/:noticeId',
                ShopListActivity: '/shops',
                ShopLocationBottomSheet: '/shops/location',
                ShopPrepareModal: '/shops/prepare',
                ShopDetailBottomSheet: '/shops/:shopId',
                ItemsActivity: '/shops/:shopId/items',
                ItemActivity: '/shops/:shopId/items/:itemId',
                ItemNutritionModal: '/shops/items/:itemId/nutrition',
                PersonalOptionActivity: '/items/:itemId/personal-options',
                OrderActivity: '/orders',
                DiscountCouponBottomSheet: '/orders/coupons',
                FingerPayActivity: '/orders/finger-pay',
                OrderLogsActivity: '/orders/logs',
                OrderLogActivity: '/orders/logs/:orderNo',
                OrderReceiptActivity: '/orders/logs/:orderId/receipt',
                CancelOrderModal: '/orders/logs/:orderNo/cancel',
                OrderCompleteActivity: '/order/done',
                TossOrderFailActivity: '/order/toss/fail',
                TossOrderSuccessActivity: '/order/toss/success',
                CustomerServiceActivity: '/customer-service',
                InquiryActivity: '/customer-service/inquiry',
                InquiryLogActivity: '/customer-service/inquiry/logs/:inquiryId',
                CloseInquiryModal: '/customer-service/inquiry/logs/:inquiryId/close',
                InquiryCommentModal: '/customer-service/inquiry/logs/:inquiryId/comment/confirm',
                InquiryCommentBottomSheet: '/customer-service/inquiry/logs/:inquiryId/comment',
                ProjectActivity: '/project',
                AccountSettingActivity: '/account',
                AccountTerminationActivity: '/account/termination',
                NickNameChangeModal: '/account/nickname-changed',
                LogoutModal: '/account/logout',
                GiftsActivity: '/gifts',
                GiftItemActivity: '/gift-items/:giftItemId',
                GiftSentActivity: '/gifts/send/:giftBoxItemId',
                GiftReceivedActivity: '/gifts/received/:giftBoxItemId',
                GiftOrderActivity: '/gifts/order',
                GiftOrderCompleteActivity: '/gifts/order/complete',
                GiftCancelModal: '/gifts/cancel/:giftBoxItemId',
                GiftCanceledModal: '/gifts/canceled',
                NewGiftBottomSheet: '/gifts/new',
                MyPrepaidCardActivity: '/prepaid-cards/my',
                PrepaidCardImagesActivity: '/prepaid-cards/images',
                PrepaidCardImageActivity: '/prepaid-cards/images/:prepaidCardImageId',
                PrepaidCardManageActivity: '/prepaid-cards/manage',
                PrepaidCardChargeActivity: '/prepaid-cards/:prepaidCardId/charge',
                PrepaidCardOrderCompleteActivity: '/prepaid-cards/order/complete',
                PrepaidCardLogActivity: '/prepaid-cards/:prepaidCardId/logs',
                DeleteAllPrepaidCardsModal: '/prepaid-cards/manage/delete-all',
                PrepaidCardChargeCompleteActivity: '/prepaid-cards/charge/complete',
                MyMenuActivity: '/my-menu',
                PointActivity: '/points',
                StampsActivity: '/stamps',
                StampScopeBottomSheet: '/stamps/select-scope',
                StampSortBottomSheet: '/stamps/sort',
                CartActivity: '/cart/:shopId',
                BarcodeModal: '/barcode',
                CouponActivity: '/coupons',
                CouponDetailActivity: '/coupons/:couponId',
                CouponDownloadModal: '/coupons/modal/download',
                ExternalShopModal: '/external-shop',
                UserPaymentCancelActivity: '/errors/user-cancel',
                PaymentFailedActivity: '/errors/payment-failed',
                AlertActivity: '/alert',
                PermissionBottomSheet: '/permissions',
                LinkActivity: '/link',
                TestActivity: '/test',
                AppTerminationModal: '/app-termination',
                ForceUpdateModal: '/force-update',
                AttendanceCheckActivity: '/attendance-check',
                EasyCardActivity: '/easy-card',
                WithdrawManualActivity: '/withdraw-manual',
                TierBenefitsBottomSheet: '/tier/benefits',
                TierHistoryActivity: '/tier/history',
                TierCalculatedDateBottomSheet: '/tier/calculated-cycles',
            },
            fallbackActivity: () => 'MainActivity',
        }),
    ],
});

export type TypeActivities = typeof activities;
